import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { showSnackbar } from '../../../api/snackbarSlice';
import { apiClient } from '../../../utils/axios';
import { printPdf } from '../../../helper/PrintPdf';
import { useDispatch, useSelector } from 'react-redux';
import { saveAs } from 'file-saver';
import PrintIcon from '@mui/icons-material/Print';
import { useNavigate } from 'react-router-dom';

const DraftDocumentActions = ({ handleDetailsClickAction, docType, row }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const pdfTemplates = useSelector((state) => state.pdfTemplates.pdfTemplates);
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const downloadPdf = async (documentType, documentContent, documentId) => {
    dispatch(showSnackbar({ message: 'Downloading document...', severity: 'info' }));

    try {
      const template = pdfTemplates.find((t) => t.document_type === documentType);

      if (!template) {
        dispatch(showSnackbar({ message: `${documentType} template not found`, severity: 'error' }));
        return;
      }

      const response = await apiClient.get(`/${documentType.toLowerCase()}/${documentId}/download-pdf`, {
        params: { template_name: template.name, is_receipt: true },
        responseType: 'blob',
      });
      saveAs(response.data, response.headers.get('x-suggested-filename'));
      dispatch(showSnackbar({ message: 'Document downloaded successfully!', severity: 'success' }));
    } catch (error) {
      dispatch(showSnackbar({ message: 'Failed to download document', severity: 'error' }));
      console.error(error);
    }
  };

  const handlePrintPdf = async (documentType, documentContent, documentId) => {
    dispatch(showSnackbar({ message: 'Printing document...', severity: 'info' }));
    try {
      const template = pdfTemplates.find((t) => t.document_type === documentType);

      if (!template) {
        dispatch(showSnackbar({ message: `${documentType} template not found`, severity: 'error' }));
        return;
      }
      await printPdf(documentType, documentId, template, true);
      dispatch(showSnackbar({ message: 'Document printed successfully!', severity: 'success' }));
    } catch (error) {
      dispatch(showSnackbar({ message: 'Failed to print document', severity: 'error' }));
      console.error(error);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDetailsClick = () => {
    handleDetailsClickAction();
    handleClose();
  };

  const handleEdit = () => {
    const documentCopy = { ...row };

    if (documentCopy.item_details && Array.isArray(documentCopy.item_details)) {
      documentCopy.item_details = documentCopy.item_details.map((item) => {
        const { _id, ...rest } = item;
        return rest;
      });
    }
    navigate(`/documents/${docType}/create`, {
      state: {
        document: documentCopy,
        editingDraft: true,
        from: `/drafts?tab=${docType}`,
      },
    });
  };

  return (
    <>
      <IconButton id="action-icon-button" onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              boxShadow: '4px 4px 10px 0px rgba(0,0,0,0.2)',
            },
          },
        }}
      >
        <MenuItem id="details" onClick={handleDetailsClick}>
          Details
        </MenuItem>
        <MenuItem id="edit" onClick={handleEdit}>
          Edit
        </MenuItem>
        <MenuItem onClick={() => downloadPdf(docType, row, row.document_id)}>Download Receipt</MenuItem>
        <MenuItem onClick={() => handlePrintPdf(docType, row, row.document_id)}>
          <PrintIcon sx={{ marginRight: 1 }} /> Print Receipt
        </MenuItem>
      </Menu>
    </>
  );
};
export default DraftDocumentActions;
